import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from './url-helper.service';
import { BooleanResult } from '../interfaces/boolean-result.interface';

@Injectable()
export class EventLogService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) { }

  public rollbackEvent(id: number): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "EventLog/Rollback/?id=" + id;
    return this.http.get<any>(url,);
  }

}
